module.exports = __webpack_public_path__ + "static/erick-morillo-6e8a7b64ed259d51295bdd239daa08da.png";